<div class="tender-reports">
  <ul class="nav nav-tabs reports-tabs px-3 pt-2">
    <li class="nav-item" *ngIf="canAccessAggregate; else bidAnalysisRestricted">
      <a class="nav-link" [routerLink]="['bid-analysis']" routerLinkActive="active">
        <i class="fas fa-chart-bar me-1"></i> Bid Analysis
      </a>
    </li>
    <ng-template #bidAnalysisRestricted>
      <li class="nav-item">
        <span class="nav-link text-muted"
              style="cursor: not-allowed;"
              ngbTooltip="Restricted during active rounds on sealed tenders" placement="bottom">
          <i class="fas fa-lock me-1"></i> Bid Analysis
        </span>
      </li>
    </ng-template>
    <li class="nav-item" *ngIf="canAccessAggregate; else bidFeeRestricted">
      <a class="nav-link" [routerLink]="['bid-fee']" routerLinkActive="active">
        <i class="fas fa-file-invoice-dollar me-1"></i> Bid Fee
      </a>
    </li>
    <ng-template #bidFeeRestricted>
      <li class="nav-item">
        <span class="nav-link text-muted"
              style="cursor: not-allowed;"
              ngbTooltip="Restricted during active rounds on sealed tenders" placement="bottom">
          <i class="fas fa-lock me-1"></i> Bid Fee
        </span>
      </li>
    </ng-template>
    <li class="nav-item" *ngIf="canViewYearOverYear; else yearOverYearRestricted">
      <a class="nav-link" [routerLink]="['year-over-year']" routerLinkActive="active">
        <i class="fas fa-chart-line me-1"></i> Year-over-Year
      </a>
    </li>
    <ng-template #yearOverYearRestricted>
      <li class="nav-item">
        <span class="nav-link text-muted"
              style="cursor: not-allowed;"
              ngbTooltip="View Reports permission required" placement="bottom">
          <i class="fas fa-lock me-1"></i> Year-over-Year
        </span>
      </li>
    </ng-template>
  </ul>

  <router-outlet></router-outlet>
</div>
